const DeliveryTypeEnum = Object.freeze({
    SAME_DAY_DELIVERY: "SAME_DAY_DELIVERY",
    NEXT_DAY_DELIVERY: "NEXT_DAY_DELIVERY",
    NEXT_DAY_PREMIUM_DELIVERY: "NEXT_DAY_PREMIUM_DELIVERY",
    INTERNATIONAL_DELIVERY: "INTERNATIONAL_DELIVERY",
    ON_DEMAND_DELIVERY: "ON_DEMAND_DELIVERY",
    ONE_TO_THREE_DAYS_DELIVERY: "ONE_TO_THREE_DAYS_DELIVERY",
    SICEPAT_SIUNTUNG_DELIVERY: "SICEPAT_SIUNTUNG_DELIVERY",
  });

  export default DeliveryTypeEnum;
